export { default, type HowItWasSectionProps, SECTION_ID as howItWasSectionId } from './HowItWasSection';
